import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@ui/lib/utils.js';

export { default as PLinkButton, type PLinkButtonProps } from './PLinkButton.vue';

const pLinkButtonCvaConfig = {
    variants: {
        size: {
            default: 'h-9 px-4 py-2 has-[>svg]:px-3',
            lg: 'h-10 px-6 py-2 has-[>svg]:px-4',
            sm: 'h-8 px-3 has-[>svg]:px-2.5',
            xs: 'h-6 px-2 has-[>svg]:px-6 paragraph-xs',
        },
    },
    defaultVariants: {
        size: 'default',
    },
} as const;

export const pLinkButtonVariants = cva(
    cn(
        'inline-flex',
        'items-center',
        'justify-center',
        'gap-2',
        'text-foreground-primary',
        'whitespace-nowrap',
        'rounded-lg',
        'paragraph-sm',
        'font-medium',
        'transition',
        'underline',
        'disabled:pointer-events-none',
        '[&_svg]:pointer-events-none',
        "[&_svg:not([class*='size-'])]:size-4",
        'shrink-0',
        '[&_svg]:shrink-0',
        'outline-none',
        'focus-visible:ring-ring-default',
        'focus-visible:ring-3',
        'disabled:opacity-50',
    ),
    pLinkButtonCvaConfig,
);

export const P_LINK_BUTTON_SIZES = Object.keys(pLinkButtonCvaConfig.variants.size);
export type PLinkButtonSize = keyof typeof pLinkButtonCvaConfig.variants.size;
export type PLinkButtonVariants = VariantProps<typeof pLinkButtonVariants>;
